import { Component } from '@angular/core';

@Component({
  selector: 'app-moneybar-legend',
  templateUrl: 'moneybar-legend.component.html',
  styleUrls: ['moneybar-legend.component.scss'],
  standalone: false,
})
export class MoneybarLegendComponent {}
